module.exports = __webpack_public_path__ + "ac060be7946211395445006131bbfb15.pdf";